import { createStyles, makeStyles } from '@material-ui/core/styles';

export const useCreateStyles = makeStyles(() => createStyles({
  formTitle: {
    paddingLeft: '9px',
    paddingBottom: '20px',
  },
}));
